//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"CheckOnFinish",1,0],[0,"CheckingMeasurementOption",1,0],[0,"FindCollinear",1,0],[0,"FindConcentric",1,0],[0,"FindConnected",1,0],[0,"FindEqualLength",1,0],[0,"FindEqualRadius",1,0],[0,"FindOrthogonal",1,0],[0,"FindOverlapping",1,0],[0,"FindParallel",1,0],[0,"FindPerpendicular",1,0],[0,"FindPointOnCurve",1,0],[0,"FindTangent",1,0],[0,"FindTangentAtVertex",1,0],[0,"FindTinyCurves",1,0],[0,"GlobalAngularTolerance",1,0],[0,"GlobalLinearTolerance",1,0],[0,"TangentAtVertexAngularTolerance",1,0],[0,"TinyCurvesLinearTolerance",1,0]],[],[]];
SPLM.SketchCheckingSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchCheckingSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchCheckingSettingsBuilder.CheckingMeasurementType = Object.freeze({
    "DisplaySize" : "DisplaySize", "ModelSize" : "ModelSize"});

export default SPLM;